var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-slider"},[_c('v-hero-slider',{attrs:{"announce":""},on:{"close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }